<template>
  <app-layout>
    <template #header>
      <div class="flex flex-row justify-between items-center">
        <h2 class="font-semibold text-xl text-gray-800 leading-tight">
          <em class="fas fa-credit-card"></em> Cartão
        </h2>
        <balance :short="true" />
      </div>
    </template>
    <div class="py-12 pt-20 pb-6">
      <flash :timeout="5000" />
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div
          class="bg-white overflow-hidden shadow-xl sm:rounded-lg py-4 flex flex-col items-center"
        >
          <div class="mt-9 mb-20">
            <div class="flex flex-col justify-center gap-5">
              <div
                class="self-center font-extrabold text-2xl text-black text-opacity-70 max-w-max border-b-2 border-yellow-400"
              >
                Confirme o endereço
              </div>
              <div class="text-black text-opacity-60 text-base">
                Precisamos da confirmação do seu endereço para prosseguir com o
                processo de solicitação do seu cartão.
              </div>

              <div
                class="border h-24 flex gap-4 justify-center items-center text-black text-opacity-60"
              >
                <span class="text-center text-base">
                  {{ completedAddress | capitalizeName }}
                </span>
                <span content="Informação" v-tippy>
                  <i
                    class="cursor-pointer text-black text-opacity-60 fas fa-info-circle"
                    @click="isShowInfo = !isShowInfo"
                  />
                </span>
              </div>
              <div class="flex justify-between mt-5">
                <button
                  class="px-5 py-2 gap-2 rounded-md uppercase border text-black text-opacity-70 text-xs font-medium"
                  @click="goBack"
                >
                  Voltar
                </button>
                <button-confirmation
                  :disabled="isAnyPropertyNull"
                  @click.native="verifyTermsPage"
                >
                  Confirmar
                </button-confirmation>
              </div>
              <div v-if="isShowInfo" class="flex flex-col gap-2 mt-8">
                <div class="text-black text-opacity-60 text-base">
                  Se o endereço exibido estiver incorreto, pedimos gentilmente que entre em contato <br />
                  com o nosso suporte através dos seguintes canais de atendimento:
                </div>
                <a
                  href="mailto:atendimento@2gofintech.com.br"
                  target="_blank"
                  class="w-72"
                >
                  <span class="text-base text-black text-opacity-60 font-bold">
                    <i class="text-yellow-400 far fa-envelope"></i>
                    atendimento@2gofintech.com.br
                  </span>
                </a>
                <a
                  href="https://api.whatsapp.com/send/?phone=5511970234560"
                  target="_blank"
                  class="w-44"
                >
                  <span class="text-base text-black text-opacity-60 font-bold">
                    <i class="text-green-400 fab fa-whatsapp"></i>
                    (11) 97023-4560
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>
<script>
import AppLayout from "./../../Layouts/AppLayout";
import Welcome from "./../../Jetstream/Welcome";
import ptBR from "vuejs-datepicker/dist/locale";
import Button from "../../Jetstream/Button";
import Balance from "../../Helpers/Balance";
import Flash from "../../Helpers/Flash";
import ConclusionTheCard from "./ConclusionTheCard";
import ButtonConfirmation from "../../Jetstream/ButtonConfirmation.vue";

export default {
  props: ["address"],
  components: {
    Flash,
    Balance,
    Button,
    AppLayout,
    Welcome,
    ConclusionTheCard,
    ButtonConfirmation,
  },
  data() {
    return {
      ptBR: ptBR,
      isShowInfo: false,
    };
  },
  computed: {
    completedAddress() {
      const {
        street,
        number,
        complement,
        neighborhood,
        city,
        zip_code,
        state,
      } = this.address[0];
      return `
            ${street ?? "--"} n° ${number ?? "--"}, ${neighborhood ?? "--"} ${
        complement ?? "--"
      }, ${zip_code ?? "--"}, ${city ?? "--"} - ${state ?? "--"}
            `;
    },
    isAnyPropertyNull() {
      const { street, number, neighborhood, city, zip_code, state } =
        this.address[0];

      return (
        street === null ||
        number === null ||
        neighborhood === null ||
        city === null ||
        zip_code === null ||
        state === null
      );
    },
  },
  created() {
    this.isShowInfo = this.isAnyPropertyNull;
  },

  methods: {
    goBack() {
      this.$inertia.get(this.route("card.index"));
    },
    verifyTermsPage() {
      this.$inertia.get(this.route("card.verify-terms"));
    },
  },
};
</script>
